/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMoneyPool} from '../api'

 export const useQueryGetMoneyPool = createReactQueryHook('getMoneyPool', getMoneyPool)
